import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks";

export default () => {
  const { response: { products } } = useAppState();

  if(!products?.hits || products.hits?.length < 1) return;
    
  const SHOPIFY_STOREFRONT_ACCESS_TOKEN = '723574495602d3cf11d972d3647acc9e';
  const SHOPIFY_STORE_URL = 'https://andie-swim-1.myshopify.com/api/2025-01/graphql.json'; 

  const [storefrontData, setStorefrontData] = useState(null); // Start as null
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    /* There are 250+ metaobjects of type color_swatches. We cannot fetch more than 250 results in one query.
      Shopify paginates the results, need to use cursor-based pagination to fetch all metaobjects. 
      metaobjects have pageInfo field, which includes hasNextPage, letting us know if we fetched all the existing objects.
   */

    let hasNextPage = true;
    let endCursor = null;
    let allSwatches = [];
    //let fabricData;

    const fetchSwatchColors = async () => {
      setLoading(true);
      try {
        while (hasNextPage) {
          const graphqlQuery = `query {
            colorSwatches: metaobjects(type: "color_swatches", first: 200, after: ${endCursor ? `"${endCursor}"` : "null"}) {
              edges {
                node {
                  id
                  handle
                  fields {
                    key
                    value
                    reference {
                      ... on MediaImage {
                        id
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }`;

          const fetchOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_ACCESS_TOKEN,
            },
            body: JSON.stringify({ query: graphqlQuery }),
          };

          const response = await fetch(SHOPIFY_STORE_URL, fetchOptions);
          if (!response.ok) throw new Error(`Failed to fetch data. Status: ${response.status}`);

          const data = await response.json();

          if (data.errors) {
            throw new Error(`GraphQL Error: ${JSON.stringify(data.errors)}`);
          }

          const colorData = data?.data?.colorSwatches;
          //fabricData = data?.data?.fabric?.edges ? [...data.data.fabric.edges] : [];

          if (colorData) {
            allSwatches = [...allSwatches, ...colorData.edges];
            hasNextPage = colorData.pageInfo.hasNextPage;
            endCursor = colorData.pageInfo.endCursor;
          } else {
            hasNextPage = false;
          }

          if (!hasNextPage) break;
        }

        const finalData = { colorSwatches: allSwatches };
        setStorefrontData(finalData);
      } catch (err) {
        console.error("Error in fetchSwatchColors:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSwatchColors();
  }, []);

  return { storefrontData };
}
